












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class QrButto extends Vue {
  @Prop() forMyself!: boolean;

  isVisible = false;
  get currentUrl(): string {
    return window.location.href;
  }

  get buttonLabel(): string {
    if (!this.isVisible) {
      if (this.forMyself) {
        return "URLのQRコードを表示";
      } else {
        return "お友達共有用にURLのQRコードを表示";
      }
    } else {
      return "QRコード非表示";
    }
  }

  toggleVisibility() {
    console.log("clicked");
    this.isVisible = !this.isVisible;
  }
}
